"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTMConfig = void 0;
const Tokens_1 = require("./Tokens");
const Types_1 = require("../../Types");
const MetamaskConnector_1 = require("../../Connectors/Wallets/MetamaskConnector");
const MathWalletConnector_1 = require("../../Connectors/Wallets/MathWalletConnector");
const Utils_1 = require("../Utils");
const MetamaskCompatibleConnector_1 = require("../../Connectors/Wallets/MetamaskCompatibleConnector");
const Factory_1 = require("../../Connectors/Factory");
const WalletConnectConnector_1 = require("../../Connectors/Wallets/WalletConnectConnector");
exports.FTMConfig = Utils_1.blockchainConfigFactory({
    blockchain: Types_1.Blockchains.FTM,
    chainId: Types_1.EthChainIds.FTM,
    publicRpc: "https://rpc.fantom.network",
    nativeToken: Tokens_1.FTMToken,
    wrappedToken: Tokens_1.FTMWrappedToken,
    upToken: Tokens_1.FTMUpToken,
    unfiToken: Tokens_1.FTMUnfiToken,
    logoURI: "https://proxy.unifiprotocol.com/ipfs/QmPN8aMAnY2PxQeebTtyg1qxz7hqwHdojRp33dm3E8K5UA",
    multicall: {
        supported: true,
        address: "0x3BF91Ba76B8B60fD92F588068fAd1e6f50B9d420",
        tryAggregate: false,
    },
    connectorFactory: Factory_1.web3ConnectorFactory,
    explorer: {
        baseUrl: "https://ftmscan.com",
        address: function (address) {
            return `${this.baseUrl}/address/${address}`;
        },
        token: function (address) {
            return `${this.baseUrl}/tokens/${address}`;
        },
        tx: function (address) {
            return `${this.baseUrl}/tx/${address}`;
        },
    },
}, [
    MetamaskConnector_1.MetamaskConnector,
    MathWalletConnector_1.MathWalletConnector,
    MetamaskCompatibleConnector_1.MetamaskCompatibleConnector,
    WalletConnectConnector_1.WalletConnectConnector,
], [
    Factory_1.createWeb3OfflineConnectorHelper(Types_1.OfflineConnectors.FTM, "https://rpc.FTM.tools"),
]);
